// extracted by mini-css-extract-plugin
export default {"-large":"ldCMi1Uns1yTxM06LfR0","promptSuggestions":"VZ3K04YSswEDBtnUQY6t"};